var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileSidebarSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.081 8.75H15.1419V5.9375C15.1419 2.66406 12.4731 0 9.1939 0C5.91469 0 3.24593 2.66406 3.24593 5.9375V8.75H2.30677C1.26979 8.75 0.428467 9.58984 0.428467 10.625V18.125C0.428467 19.1602 1.26979 20 2.30677 20H16.081C17.118 20 17.9593 19.1602 17.9593 18.125V10.625C17.9593 9.58984 17.118 8.75 16.081 8.75ZM10.7592 15.3125C10.7592 16.1758 10.0587 16.875 9.1939 16.875C8.32909 16.875 7.62864 16.1758 7.62864 15.3125V13.4375C7.62864 12.5742 8.32909 11.875 9.1939 11.875C10.0587 11.875 10.7592 12.5742 10.7592 13.4375V15.3125ZM12.0114 8.75H6.37644V5.9375C6.37644 4.38672 7.64038 3.125 9.1939 3.125C10.7474 3.125 12.0114 4.38672 12.0114 5.9375V8.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSidebarSecurity);
export default __webpack_public_path__ + "static/media/profile-sidebar-security.1f71a728.svg";
export { ForwardRef as ReactComponent };